import React, { Component } from 'react';
import './App.scss';
import './fonts/font.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import ScrollToTop from 'components/util/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from 'pages/main/Home';
import Login from 'pages/auth/Login';
import ForgotPassword from 'pages/auth/ForgotPassword';
import Order from 'pages/purchase/Order';
import MyPurchases from 'pages/purchase/MyPurchases';
import PurchasedBundle from 'pages/purchase/PurchasedBundle';
import ImageBundles from 'pages/image-bundles/ImageBundles';
import ImageBundle from 'pages/image-bundles/ImageBundle';
import AudioBundles from 'pages/audio-bundles/AudioBundles';
import AudioBundle from 'pages/audio-bundles/AudioBundle';
import Templates from 'pages/templates/Templates';
import Template from 'pages/templates/Template';
import Category from 'pages/image-bundles/Category';
import Ultimate from 'pages/purchase/Ultimate';
import OrderUltimate from 'pages/purchase/OrderUltimate';
import RedirectToCheckout from 'pages/redirect-to-checkout/RedirectToCheckout';
import store from './store';
import { asyncGetUserInfo, asyncGetPaymentInfo } from 'actions/user';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import AppConfig from './util/config';
import { asyncFetchSsoAppStatus } from 'actions/sso-app';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(AppConfig.STRIPE_PUBLIC_KEY);

export default class App extends Component {
  componentDidMount() {
    const { auth, user } = store.getState();
    if (auth.isAuthenticated) {
      if (!user.id && !user.isFetching) {
        store.dispatch(asyncGetUserInfo());
      }
      if (!user.paymentInfo) {
        store.dispatch(asyncGetPaymentInfo());
      }
    }

    store.dispatch(asyncFetchSsoAppStatus());
  }

  render() {
    return (
      <Elements stripe={stripePromise}>
        <Provider store={store}>
          <Router basename="/">
            <ScrollToTop />
            <Route path={['/home/:query', '/home', '/']} exact component={Home} />
            <Route path="/ultimate" exact component={Ultimate} />
            <Route path="/ultimate/order" exact component={OrderUltimate} />
            <Route path="/login" exact component={Login} />
            <Route path="/forgot-password" exact component={ForgotPassword} />
            <Route path={['/image-bundles/:query', '/image-bundles']} component={ImageBundles} />
            <Route path="/image-bundle/:id/:slug" exact component={ImageBundle} />
            <Route path={['/audio-bundles/:query', '/audio-bundles']} component={AudioBundles} />
            <Route path="/audio-bundle/:id/:slug" exact component={AudioBundle} />
            <Route path={['/templates/:query', '/templates']} component={Templates} />
            <Route path="/template/:id/:slug" exact component={Template} />
            <Route path="/order/:type/:id/:slug/" component={Order} />
            <Route path={['/category/:categ']} component={Category} /> {/*  Dont need */}
            <Route path={['/search/:query', '/search']} component={ImageBundles} /> {/*  Dont need */}
            <Route path="/my-purchases/:type" exact component={MyPurchases} />
            <Route path="/my-purchase/:id" exact component={PurchasedBundle} />
            <Route path="/redirect-to-checkout" exact component={RedirectToCheckout} />
            <ToastContainer
              position="top-center"
              autoClose={false}
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              pauseOnVisibilityChange
              draggable
            />
          </Router>
        </Provider>
      </Elements>
    );
  }
}
